import {
  buildPageableParams,
  Page,
  PageableArgs,
  servicesApi,
  UtilisateurDto,
  UtilisateurProjection,
} from '@common/services';
import { queryDownloadFile } from '../common/pageable/query-download-file';
import { queryUntilLastPage } from '../common/pageable/query-until-last-page';

const utilisateursApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    getUtilisateursFc: build.query<Page<UtilisateurDto>, PageableArgs<UtilisateurProjection>, any>({
      query: (pageable) => ({
        url: `utilisateurs/iam/fc`,
        params: buildPageableParams(pageable),
      }),
      providesTags: ['Utilisateurs'],
    }),

    getUtilisateurs: build.query<Page<UtilisateurDto>, PageableArgs<UtilisateurProjection>, any>({
      query: (args = {}) => ({
        url: 'utilisateurs',
        params: buildPageableParams(args),
      }),
      providesTags: ['Utilisateurs'],
    }),

    getAllUtilisateurs: build.query<UtilisateurDto[], PageableArgs<UtilisateurProjection>, any>({
      queryFn: (args = {}, _api, _extraOptions, baseQuery) => queryUntilLastPage({
        baseQuery,
        url: 'utilisateurs',
        params: buildPageableParams(args),
      }),
      providesTags: ['Utilisateurs'],
    }),

    downloadUtilisateurs: build.mutation<void, void, any>({
      queryFn: (_arg, _api, _extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `utilisateurs/export`,
      }),
    }),
  }),
});

export const {
  useGetUtilisateursFcQuery,
  useGetUtilisateursQuery,
  useLazyGetAllUtilisateursQuery,
  useGetAllUtilisateursQuery,
  useDownloadUtilisateursMutation,
} = utilisateursApi;